import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AskExpert from "@/components/AskExpert";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import BrushDetail from "@/pages/BrushDetail";
import Quiz from "@/pages/Quiz";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import Cart from "@/pages/Cart";
import ShopSuccess from "@/pages/ShopSuccess";
import FreeGuide from "@/pages/FreeGuide";
import AdminBroadcast from "@/pages/AdminBroadcast";
import Artistry from "@/pages/Artistry";
import Tutorials from "@/pages/Tutorials";
import TutorialDetail from "@/pages/TutorialDetail";
import BrushId from "@/pages/BrushId";
import LookBuilder from "@/pages/LookBuilder";
import LookBuilderResult from "@/pages/LookBuilderResult";
import ThirtyDay from "@/pages/ThirtyDay";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ReturnPolicy from "@/pages/ReturnPolicy";
import { CartProvider } from "@/context/CartContext";
import { AccessProvider } from "@/context/AccessContext";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [expertOpen, setExpertOpen] = useState(false);
  const openExpert = () => setExpertOpen(true);

  return (
    <div className="App">
      <HelmetProvider>
        <AccessProvider>
          <CartProvider>
            <BrowserRouter>
            <Navbar onOpenExpert={openExpert} />
            <main>
              <Routes>
                <Route path="/" element={<Home onOpenExpert={openExpert} />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/brush/:id" element={<BrushDetail />} />
                <Route path="/quiz" element={<Quiz />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/about" element={<About />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/shop/success" element={<ShopSuccess />} />
                <Route path="/free-guide" element={<FreeGuide />} />
                <Route path="/admin/broadcast" element={<AdminBroadcast />} />
                <Route path="/artistry" element={<Artistry />} />
                <Route path="/tutorials" element={<Tutorials />} />
                <Route path="/tutorials/:id" element={<TutorialDetail />} />
                <Route path="/brush-id" element={<BrushId />} />
                <Route path="/look-builder" element={<LookBuilder />} />
                <Route path="/look-builder/result" element={<LookBuilderResult />} />
                <Route path="/thirty-day" element={<ThirtyDay />} />
                <Route path="/thirty-day/success" element={<ThirtyDay />} />
                <Route path="/return-policy" element={<ReturnPolicy />} />
              </Routes>
            </main>
            <Footer />
            <AskExpert open={expertOpen} onOpenChange={setExpertOpen} />
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </CartProvider>
        </AccessProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
